import React, { Component } from 'react';
import {
  Col
} from 'react-bootstrap';
import './Login.css';
import { withRouter } from 'react-router-dom';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
    };
  }

  getURLSession(auth, curUrl) {
    return new Promise((resolve, reject) => {
      auth.userhandler = {
        onSuccess: function(result) {
          resolve(result);
        },
        onFailure: function(err) {
          console.log("Error starting user session!" + err);
          alert("There was a problem authenticating your session.");
          reject(err);
        }
      };
      // This function will initiate a standard auth callback
      auth.parseCognitoWebResponse(curUrl);
    });
  }

  // Check whether login has received a token from SSO
  async componentDidMount() {
    const curUrl = window.location.href;
    // Check if this was sso request
    // Which will route to Cognito SSO.
    if (window.location.pathname.toLowerCase() === "/login/sso")
    {
      this.props.auth.getSession();
    }
    // Should this be a return from sso site, process the url and see if we have tokens
    await this.getURLSession(this.props.auth, curUrl);
    this.props.history.push("/");
    this.setState({ isLoading: false });
  }
  
  render() {
    return ! this.state.isLoading
        &&(
        <div className="Login">
            <Col xs={12} md={12}>
                <h1>
                    Logging in...
                </h1>
            </Col>
        </div>
    );
  }
}

export default withRouter(Login);


// WEBPACK FOOTER //
// ./src/containers/Login.js